import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { getErrorState, errorStates } from '../helpers/errorStates'

export const ErrorStatusContext = React.createContext({})

export default function ErrorStatusProvider({ errorStatusCode, isGroupError, children }) {
  const [errorStatus, setPrivateErrorStatus] = useState()

  const setErrorStatus = useCallback((newStatus) => {
    if (!Object.values(errorStates).includes(newStatus)) throw new Error(`Invalid error status ${newStatus} provided.`)
    setPrivateErrorStatus(newStatus)
  }, [])

  useEffect(() => {
    setPrivateErrorStatus(errorStatusCode ? getErrorState(errorStatusCode) : null)
  }, [errorStatusCode])

  const errorStatusContextValue = useMemo(
    () => ({
      errorStatus,
      setErrorStatus,
      isGroupError,
    }),
    [errorStatus, setErrorStatus, isGroupError]
  )

  return <ErrorStatusContext.Provider value={errorStatusContextValue}>{children}</ErrorStatusContext.Provider>
}
